import { render, staticRenderFns } from "./WarningView.vue?vue&type=template&id=6b8ac4ec&scoped=true"
import script from "./WarningView.vue?vue&type=script&lang=js"
export * from "./WarningView.vue?vue&type=script&lang=js"
import style0 from "./WarningView.vue?vue&type=style&index=0&id=6b8ac4ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8ac4ec",
  null
  
)

export default component.exports